import React, {PropsWithChildren} from "react";

export function NumberOrDashWrapper(props: PropsWithChildren<any>): JSX.Element {
    const value = !props.children || props.children === 0 ? "-" : String(props.children)
    return (
        <>
            {value}
        </>
    );
}